var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarmBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 17.5C18.1716 17.5 17.5 16.8284 17.5 16V11.138C17.6193 7.21437 14.8594 3.78997 11 3.073V1C11 0.447715 10.5523 0 10 0C9.44771 0 9 0.447715 9 1V3.073C5.14059 3.78997 2.38069 7.21437 2.5 11.138V16C2.5 16.8284 1.82843 17.5 1 17.5C0.447715 17.5 0 17.9477 0 18.5C0 19.0523 0.447715 19.5 1 19.5H19C19.5523 19.5 20 19.0523 20 18.5C20 17.9477 19.5523 17.5 19 17.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.236 21H7.76401C7.63693 21.0002 7.53024 21.0957 7.51601 21.222C7.50511 21.3143 7.49977 21.4071 7.50001 21.5C7.50001 22.8807 8.6193 24 10 24C11.3807 24 12.5 22.8807 12.5 21.5C12.5002 21.4071 12.4949 21.3143 12.484 21.222C12.4707 21.0953 12.3634 20.9993 12.236 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmBell);
export default __webpack_public_path__ + "static/media/alarm-bell.0a88084862b4e0310dcbbffa8a17b2b9.svg";
export { ForwardRef as ReactComponent };